import { serverInfo } from "../config/serverConfig";
import { checkResponse } from "../utils/apiError";
import { apiFetch } from "./apiFetch";

/**
 * Account programs list (Event / Participants filters).
 * @param {{ account_id: string }} params
 * @returns {Promise<object[]>}
 */
export async function fetchPrograms({ account_id }) {
  if (!account_id) throw new Error("account_id is required");
  const resp = await apiFetch(serverInfo.serverUrl + "/getProgram", {
    method: "POST",
    body: JSON.stringify({ account_id }),
  });
  checkResponse(resp);
  const data = await resp.json();
  return Array.isArray(data) ? data : [];
}

/**
 * Program organizers (Hosted By). Pass program_id to scope members to one program.
 * @param {{ account_id: string, program_id?: string }} params
 * @returns {Promise<object[]>}
 */
export async function fetchProgramOrganizers({ account_id, program_id } = {}) {
  if (!account_id) throw new Error("account_id is required");
  const body = { account_id };
  const pid = program_id != null ? String(program_id).trim() : "";
  if (pid) body.program_id = pid;
  const resp = await apiFetch(serverInfo.serverUrl + "/getProgramOrganizers", {
    method: "POST",
    body: JSON.stringify(body),
  });
  checkResponse(resp);
  const data = await resp.json();
  return Array.isArray(data) ? data : [];
}
